export default "__VITE_PUBLIC_ASSET__79e02b40__"